import React from 'react';

// Hand-drawn moment icons, ported verbatim from redesign/26-09-03
// ("VBoard Landing (pentru Marius).html", header#top). Sizing comes from the
// caller via className so the strip controls its own scale.

export const PrepareIcon = ({ className }) => (
    <svg aria-hidden="true" viewBox="0 0 150 104" className={className}>
        <g fill="none" stroke="#0f7d84" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14 12 C 44 8, 74 14, 100 10 C 103 36, 99 66, 102 92 C 74 96, 42 90, 16 94 C 12 68, 17 38, 14 12"></path>
            <path d="M28 34 C 44 31, 58 36, 72 33"></path>
            <path d="M28 50 C 48 47, 66 52, 84 49"></path>
        </g>
        <path
            d="M28 70 C 42 67, 56 72, 70 69"
            stroke="#ffc83d"
            strokeWidth="7"
            strokeLinecap="round"
            fill="none"
        ></path>
        <g fill="none" stroke="#f5822c" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round">
            <path d="M112 20 C 126 16, 140 24, 142 36 C 144 50, 130 58, 118 54 C 108 51, 104 40, 110 32"></path>
            <path d="M116 36 l6 6 l11 -13"></path>
        </g>
    </svg>
);

export const BoardReadyIcon = ({ className }) => (
    <svg aria-hidden="true" viewBox="0 0 150 104" className={className}>
        <g fill="none" stroke="#0f7d84" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round">
            <path d="M10 10 C 54 6, 100 13, 140 8 C 143 30, 138 56, 141 76 C 98 80, 52 73, 12 78 C 8 56, 13 32, 10 10"></path>
            <path d="M74 78 C 75 86, 73 94, 74 100 M56 100 C 66 97, 84 102, 94 99"></path>
        </g>
        <path
            d="M28 58 C 36 44, 44 32, 50 24 C 58 36, 66 48, 74 60 C 58 62, 42 57, 28 58"
            fill="none"
            stroke="#f5822c"
            strokeWidth="2.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        ></path>
        <path
            d="M92 30 C 106 26, 118 34, 118 46 C 118 58, 104 64, 94 60"
            fill="none"
            stroke="#ffc83d"
            strokeWidth="3"
            strokeLinecap="round"
        ></path>
    </svg>
);

export const DemonstrateIcon = ({ className }) => (
    <svg aria-hidden="true" viewBox="0 0 150 104" className={className}>
        <g fill="none" stroke="#0f7d84" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round">
            <path d="M10 12 C 54 8, 100 15, 140 10 C 143 36, 138 66, 141 92 C 98 96, 52 89, 12 94 C 8 66, 13 38, 10 12"></path>
            <path d="M24 34 C 40 31, 54 36, 68 33 M24 48 C 42 45, 58 50, 76 47"></path>
            <path d="M24 78 C 34 62, 44 50, 50 42 C 58 54, 66 66, 74 80 C 58 82, 40 77, 24 78"></path>
        </g>
        <path
            d="M92 34 C 108 30, 122 40, 120 54 C 118 66, 104 72, 94 66"
            fill="none"
            stroke="#ffc83d"
            strokeWidth="6"
            strokeLinecap="round"
        ></path>
        <path
            d="M88 84 C 102 81, 118 86, 130 82"
            stroke="#f5822c"
            strokeWidth="6"
            strokeLinecap="round"
            fill="none"
        ></path>
    </svg>
);

export const ShareIcon = ({ className }) => (
    <svg aria-hidden="true" viewBox="0 0 150 104" className={className}>
        <g fill="none" stroke="#0f7d84" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20 32 C 60 28, 100 34, 132 30 C 135 52, 130 74, 133 92 C 96 96, 56 89, 22 93 C 18 72, 23 52, 20 32"></path>
            <path d="M20 34 C 46 56, 72 68, 132 30"></path>
        </g>
        <g fill="none" stroke="#f5822c" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round">
            <path d="M76 4 C 78 16, 75 28, 76 40"></path>
            <path d="M66 30 C 71 35, 74 38, 76 42 C 80 37, 83 34, 88 29"></path>
        </g>
        <path
            d="M120 76 C 130 72, 140 78, 144 84"
            stroke="#ffc83d"
            strokeWidth="3.4"
            strokeLinecap="round"
            fill="none"
        ></path>
    </svg>
);
